export default function (value) {
    try {
        return value.toFixed(2).replace('.', ',');
    } catch (e) {
        return value;
    }
}
